type PasswordCredentialConstructor = new (values: {
  id: string; password: string; name: string;
}) => Credential;

export function saveRegistrationCredential(id: string, password: string, name: string): void {
  const CredentialType = (window as Window & { PasswordCredential?: PasswordCredentialConstructor }).PasswordCredential;
  if (!window.isSecureContext || !CredentialType || !navigator.credentials?.store) return;
  try {
    // The browser owns consent, encryption and persistence. Never use web storage.
    const credential = new CredentialType({ id, password, name });
    void navigator.credentials.store(credential).catch(function () {
      // Disabled/unsupported password managers must not interrupt registration.
    });
  } catch {
    // Native autocomplete remains available when this optional API is unsupported.
  }
}
